import { ApplicationDetailsDto } from '../../../legacy/shared-types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { applicationsApi } from 'api/applications';
import dayjs from 'dayjs';
import { ApplicationDetailsFormatted, IDocumentFormatted } from './types';

function formatCustomerName(customer?: { firstName?: string; lastName?: string }): string {
  if (!customer) {
    return '';
  }

  return `${customer.firstName ?? ''} ${customer.lastName ?? ''}`.trim();
}

export const applicationDetailsTrasnformer = (application: ApplicationDetailsDto): ApplicationDetailsFormatted => ({
  id: application.id,
  applicant1: formatCustomerName(application.customers?.[0]),
  applicant2: formatCustomerName(application.customers?.[1]) || undefined,
  salesforceId: application.referenceNumber,
  financeAmount: application.financeAmount,
  status: application.status,
  ftv: application.ftv,
  propertyAddress:
    application.property &&
    `${application.property.address1}, ${application.property.town}, ${application.property.postcode}`,
  propertyId: application.property?.id || null,
  valuation: application.property?.valuation,
  files: (application.docs ?? []).reduce<Record<string, IDocumentFormatted[]>>((acc, doc) => {
    if (!acc[doc.source.toLowerCase()]) acc[doc.source.toLowerCase()] = [];

    acc[doc.source.toLowerCase()].push({
      ...doc,
      url: `/${doc.id}`,
      createdAtFormatted: dayjs(doc.createdAt).format('DD/MM/YYYY HH:mm'),
    });

    return acc;
  }, {}),
  notes: application.notes,
});

export const applicationByReferenceNumberQueryKey = (referenceNumber: string) =>
  ['analystApplications', 'by-reference', referenceNumber] as const;

export const useApplicationByReferenceNumber = (referenceNumber: string): UseQueryResult<ApplicationDetailsFormatted> =>
  useQuery(
    applicationByReferenceNumberQueryKey(referenceNumber),
    () => applicationsApi.getByReferenceNumber(referenceNumber),
    {
      enabled: Boolean(referenceNumber),
      keepPreviousData: true,
      select: application => applicationDetailsTrasnformer(application),
    },
  );
